import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={120}
      height={120}
      fill="none"
      viewBox="0 0 130 130"
    >
      <g clipPath="url(#a)">
        <path
          fill="#C75018"
          d="M98.073-2.224H83.076L60.58 14.647l7.1 5.32a7.563 7.563 0 0 0 2.402-1.195l27.99-20.996Z"
        />
        <g filter="url(#b)">
          <path
            fill="url(#c)"
            d="M22.507 16.77v82.484c0 4.136 3.362 7.498 7.498 7.498h59.989a7.505 7.505 0 0 0 7.498-7.498V16.77c0-4.136-3.362-7.499-7.498-7.499H30.005c-4.136 0-7.498 3.363-7.498 7.499Zm56.239 7.498H41.253a3.745 3.745 0 0 1-3.75-3.749 3.745 3.745 0 0 1 3.75-3.75h37.493a3.745 3.745 0 0 1 3.75 3.75 3.745 3.745 0 0 1-3.75 3.75Z"
          />
          <path
            stroke="url(#d)"
            strokeWidth={0.56}
            d="M22.787 99.254V16.77a7.226 7.226 0 0 1 7.218-7.219h59.989a7.225 7.225 0 0 1 7.218 7.219v82.484a7.225 7.225 0 0 1-7.218 7.218H30.005a7.225 7.225 0 0 1-7.218-7.218Zm18.466-74.706h37.493c2.228 0 4.03-1.8 4.03-4.029 0-2.228-1.802-4.03-4.03-4.03H41.253c-2.228 0-4.03 1.802-4.03 4.03 0 2.229 1.802 4.03 4.03 4.03Z"
          />
        </g>
        <mask
          id="e"
          width={75}
          height={98}
          x={23}
          y={9}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "alpha",
          }}
        >
          <path fill="#fff" d="M23 9h75v98H23z" />
        </mask>
        <g mask="url(#e)">
          <path
            stroke="#fff"
            strokeOpacity={0.2}
            strokeWidth={0.5}
            d="M102.75 76.5c0 6.357-4.663 12.165-12.319 16.398-7.647 4.229-18.23 6.852-29.931 6.852-11.702 0-22.284-2.623-29.931-6.852C22.913 88.665 18.25 82.857 18.25 76.5c0-6.357 4.663-12.165 12.319-16.398 7.647-4.229 18.23-6.852 29.931-6.852 11.702 0 22.284 2.623 29.931 6.852 7.656 4.233 12.319 10.041 12.319 16.398Z"
          />
        </g>
        <ellipse
          cx={60}
          cy={75.5}
          fill="#F77F4A"
          fillOpacity={0.92}
          rx={28}
          ry={16.5}
        />
        <rect width={29} height={32} x={50} y={39} fill="url(#f)" rx={3} />
        <path fill="#FE9E52" d="M46 46h23v24H46z" />
        <path
          fill="#fff"
          d="M53.583 77.99a1.807 1.807 0 0 1-1.2-.539l-2.398-2.74a1.147 1.147 0 0 0-.361-.285 1.114 1.114 0 0 0-1.276.197l-.084.087-2.414 2.741a2.276 2.276 0 0 1-1.255.54.756.756 0 0 1-.537-.117 1.6 1.6 0 0 1-.742-.564 1.682 1.682 0 0 1-.316-.894V44.648a1.679 1.679 0 0 1 .118-.633c.08-.201.197-.383.345-.537.148-.153.325-.274.52-.357.194-.082.402-.123.612-.12h26.81c.42-.001.824.17 1.123.476.299.306.468.722.472 1.156v31.725c-.012.325-.12.639-.31.9-.188.26-.45.454-.748.558-.194.075-.4.114-.607.116a1.374 1.374 0 0 1-.602-.144 1.419 1.419 0 0 1-.485-.395l-2.342-2.712a1.156 1.156 0 0 0-.811-.388c-.31-.014-.611.1-.84.315l-2.582 2.829a1.65 1.65 0 0 1-.537.372 1.606 1.606 0 0 1-1.806-.372l-2.384-2.727a1.16 1.16 0 0 0-.363-.28 1.126 1.126 0 0 0-1.274.193l-.085.087-2.47 2.741c-.31.325-.729.518-1.17.54Zm-2.54-18.15a1.576 1.576 0 0 0-1.03.53 1.678 1.678 0 0 0-.414 1.11c0 .41.148.805.415 1.108.267.304.634.493 1.03.532h13.955c.221.021.444-.005.655-.078.21-.072.404-.19.568-.344.164-.154.296-.343.385-.553a1.694 1.694 0 0 0-.385-1.884 1.584 1.584 0 0 0-.568-.344 1.546 1.546 0 0 0-.655-.078H51.043Zm0-7.888c-.416.018-.81.198-1.103.503a1.734 1.734 0 0 0-.477 1.144c.014.429.185.836.478 1.139.294.303.688.48 1.102.494H62.05a1.61 1.61 0 0 0 1.129-.48c.302-.304.48-.717.494-1.153a1.748 1.748 0 0 0-.487-1.145 1.64 1.64 0 0 0-1.108-.502H51.043Z"
        />
        <g filter="url(#g)">
          <path
            fill="#FFBEA2"
            d="M37.984-2.224H22.987L50.99 18.77c.726.54 1.535.95 2.401 1.196.668.199 1.36.293 2.063.304h10.029c.715 0 1.418-.105 2.097-.304L37.984-2.224Z"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="c"
          x1={60}
          x2={59.999}
          y1={9}
          y2={106.752}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FC7032" />
          <stop offset={1} stopColor="#FFC46C" />
        </linearGradient>
        <linearGradient
          id="d"
          x1={26}
          x2={94.5}
          y1={11.5}
          y2={105.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.406} stopColor="#FFC7AE" />
          <stop offset={1} stopColor="#FC7032" />
          <stop offset={1} stopColor="#FFC16A" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={64.5}
          x2={64.5}
          y1={39}
          y2={71}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.75} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.64} />
        </linearGradient>
        <filter
          id="b"
          width={84.985}
          height={107.481}
          x={17.507}
          y={6.271}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.0783854 0 0 0 0 0.100868 0 0 0 0 0.145833 0 0 0 0.62 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11064_347"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_11064_347"
            result="shape"
          />
        </filter>
        <filter
          id="g"
          width={48.593}
          height={26.496}
          x={20.987}
          y={-2.224}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={1} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.0433333 0 0 0 0 0.133333 0 0 0 0 0.0910257 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11064_347"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_11064_347"
            result="shape"
          />
        </filter>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h120v120H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
